// ////////////////////////////////////////////////////

import { range } from "pdf-lib";

// Location
export const defaultLocationFilterValue = {
  criteria_type_option: {
    criteria_type: { name: "no_value_comparison" },
    custom_controller_method: "location_range",
    value_obtainment: "from_custom_controller_method",
  },
  criteria_value: {
    value_type: "location",
    location: {
      name: "",
      city: "",
      state: "",
      country: "",
      latitude: "",
      longitude: "",
      range: 10,
    },
  },
  branches: [localStorage.getItem("selectedOffice")],
};

// ////////////////////////////////////////////////////
// Oral Health
export const defaultOralHealthScoreRange = {
  criteria_type_option: {
    criteria_type: { name: "no_value_comparison" },
    custom_controller_method: "health_score_range",
    value_obtainment: "from_custom_controller_method",
  },
  criteria_value: {
    value_type: "char_value",
    char_value: "",
    integer_value: undefined,
  },
  branches: [localStorage.getItem("selectedOffice")],
};

// ////////////////////////////////////////////////////
// Identification
export const defaultFirstName = {
  criteria_type_option: {
    criteria_type: { name: "char_comparison" },
    lead_field: "lead_user.first_name",
    value_obtainment: "from_lead_field",
    allowed_operators: ["iexact"],
  },
  criteria_operator: { name: "iexact" },
  criteria_value: {
    value_type: "char_value",
    char_value: "",
  },
  branches: [localStorage.getItem("selectedOffice")],
};

export const defaultLastName = {
  criteria_type_option: {
    criteria_type: { name: "char_comparison" },
    lead_field: "lead_user.last_name",
    value_obtainment: "from_lead_field",
    allowed_operators: ["iexact"],
  },
  criteria_operator: { name: "iexact" },
  criteria_value: {
    value_type: "char_value",
    char_value: "",
  },
  branches: [localStorage.getItem("selectedOffice")],
};

export const defaultGender = {
  criteria_type_option: {
    criteria_type: { name: "char_comparison" },
    lead_field: "lead_user.gender",
    value_obtainment: "from_lead_field",
    allowed_operators: ["exact"],
  },
  criteria_operator: { name: "exact" },
  criteria_value: {
    value_type: "char_value",
    char_value: "",
  },
  branches: [localStorage.getItem("selectedOffice")],
};

export const defaultAge = {
  criteria_type_option: {
    criteria_type: { name: "no_value_comparison" },
    custom_controller_method: "age_range_criteria",
    value_obtainment: "from_custom_controller_method",
  },
  criteria_value: {
    value_type: "age_range",
    age_range: {
      lower_age: undefined,
      upper_age: undefined,
    },
  },
  branches: [localStorage.getItem("selectedOffice")],
};

export const defaultJoinedDateRange = {
  criteria_type_option: {
    criteria_type: { name: "no_value_comparison" },
    custom_controller_method: "date_joined_range_criteria",
    value_obtainment: "from_custom_controller_method",
  },
  criteria_value: {
    value_type: "date_range",
    date_range: {
      lower: "",
      upper: "",
    },
  },
  branches: [localStorage.getItem("selectedOffice")],
};

export const defaultBirthDateRange = {
  criteria_type_option: {
    criteria_type: { name: "no_value_comparison" },
    custom_controller_method: "birth_date_range_criteria",
    value_obtainment: "from_custom_controller_method",
  },
  criteria_value: {
    value_type: "date_range",
    date_range: {
      lower: "",
      upper: "",
    },
  },
  branches: [localStorage.getItem("selectedOffice")],
};

// ////////////////////////////////////////////////////
// Insurance
export const defaultInsurance = {
  criteria_type_option: {
    criteria_type: { name: "no_value_comparison" },
    custom_controller_method: "insurance_criteria",
    value_obtainment: "from_custom_controller_method",
  },
  criteria_value: {
    value_type: "char_value",
    char_value: "",
    float_value: undefined,
    text_value: "",
  },
  branches: [localStorage.getItem("selectedOffice")],
};

// ////////////////////////////////////////////////////
// Patient history
export const defaultPatientHistory = {
  criteria_type_option: {
    criteria_type: { name: "no_value_comparison" },
    custom_controller_method: "patient_history_criteria",
    value_obtainment: "from_custom_controller_method",
  },
  criteria_value: {
    value_type: "date_range",
    integer_value: undefined,
    date_range: {
      lower: "",
      upper: "",
    },
  },
  branches: [localStorage.getItem("selectedOffice")],
};

// ////////////////////////////////////////////////////
// Payment
export const defaultPaymentCreatedDate = {
  criteria_type_option: {
    criteria_type: { name: "no_value_comparison" },
    custom_controller_method: "payment_created_date_range_criteria",
    value_obtainment: "from_custom_controller_method",
  },
  criteria_value: {
    value_type: "date_range",
    date_range: {
      lower: "",
      upper: "",
    },
  },
  branches: [localStorage.getItem("selectedOffice")],
};

export const defaultPaymentDateRange = {
  criteria_type_option: {
    criteria_type: { name: "no_value_comparison" },
    custom_controller_method: "payment_due_date_range_criteria",
    value_obtainment: "from_custom_controller_method",
  },
  criteria_value: {
    value_type: "date_range",
    date_range: {
      lower: "",
      upper: "",
    },
  },
  branches: [localStorage.getItem("selectedOffice")],
};

export const defaultPaymentAmountRange = {
  criteria_type_option: {
    criteria_type: { name: "no_value_comparison" },
    custom_controller_method: "payment_amount_range_criteria",
    value_obtainment: "from_custom_controller_method",
  },
  criteria_value: {
    value_type: "integer_value",
    integer_value: undefined,
    float_value: undefined,
  },
  branches: [localStorage.getItem("selectedOffice")],
};

export const defaultPaymentPaymentType = {
  criteria_type_option: {
    criteria_type: { name: "char_comparison" },
    lead_field: "lead_user.paymentrequest.payment_type",
    value_obtainment: "from_lead_field",
    allowed_operators: ["exact"],
  },
  criteria_operator: { name: "exact" },
  criteria_value: {
    value_type: "char_value",
    char_value: "",
  },
  branches: [localStorage.getItem("selectedOffice")],
};
